module.exports = __webpack_public_path__ + "static/media/smtx--data-platform-brand-white.6e8fb892.svg";